import { type } from '@ngrx/signals'
import { eventGroup } from '@ngrx/signals/events'

import type { SendMessagesPayload, SendMessagesResponse } from '../../models/api.model'
import type { Conversation } from '../../models/conversation.model'
import type { Message } from '../../models/message.model'

export const sendingEvents = eventGroup({
  source: 'Sending',
  events: {
    sendMessage: type<{
      conversation: Conversation
      payload: SendMessagesPayload
      fakeMessages: Message[]
    }>(),
    sendFakeMessageSuccess: type<{
      payload: SendMessagesPayload
      fakeMessages: Message[]
      conversation: Conversation
    }>(),
    sendRealMessageSuccess: type<{
      response: SendMessagesResponse
      payload: SendMessagesPayload
      profile_id: number
      hadFake: boolean
    }>(),
    sendMessageSuccess: type<{
      conversation: Conversation
      messages: Message[]
    }>(),
    sendMessageFailure: type<{
      profile_id: number
      error: any
      payload: SendMessagesPayload
    }>(),
    sendMessageEnd: type<void>(),
  },
})
